export default "__VITE_ASSET__Bpg6uzD2__"